import type { ScheduleModel } from '@reducers/orm/schedule/schedule.model';
import type { TeamModel } from '@reducers/orm/team/team.model';

/** A shift rendered in a row that does not own it: another team's, or another department's. */
export function isScheduleDisabled(
  schedule: ScheduleModel,
  team: TeamModel | undefined,
  departmentId: string | undefined,
) {
  if (!team) {
    return false;
  }

  return schedule.team_id !== team.id || schedule.department_id !== departmentId;
}
